module.exports = __webpack_public_path__ + "img/generic-product.450caf5b.svg";